<template>
  <div class="main_body">
    <!-- 曜日 -->
    <el-checkbox-group v-model="days" @change="handleChange">
      <el-checkbox-button :label="10" v-show="false"> </el-checkbox-button>
      <el-checkbox-button :label="1">
        {{ $t("label.system.openMeetingRoomSetting.create.monday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="2">
        {{ $t("label.system.openMeetingRoomSetting.create.tuesday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="3">
        {{ $t("label.system.openMeetingRoomSetting.create.wednesday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="4">
        {{ $t("label.system.openMeetingRoomSetting.create.thursday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="5">
        {{ $t("label.system.openMeetingRoomSetting.create.friday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="6">
        {{ $t("label.system.openMeetingRoomSetting.create.saturday") }}
      </el-checkbox-button>
      <el-checkbox-button :label="0">
        {{ $t("label.system.openMeetingRoomSetting.create.sunday") }}
      </el-checkbox-button>
    </el-checkbox-group>
  </div>
</template>
<script>
// const weeksDay = ['','日','月','火','水','木','金','土'];
export default {
  data() {
    return {
      days: [],
    };
  },
  props: {
    day: Array,
  },
  watch: {
    day: {
      deep: true,
      immediate: true,
      handler(val) {
        this.days = val;
      },
    },
  },
  methods: {
    handleChange() {
      this.$emit("getDayValue", this.days);
    },
  },

  mounted() {},
};
</script>
<style lang="scss" scoped>
.main_body {
  ::v-deep .el-checkbox-button {
    margin-left: 8px;
    border: 0 !important;
  }

  ::v-deep .el-checkbox-button__inner {
    background-color: #f2f2ed;
    border: none !important;
    border-radius: 50% !important;
    font-size: 13px;
    color: var(--theme-color-primary);
    width: 40px;
    height: 40px;
    padding-left: 10px;
    padding-top: 14px;
    box-shadow: 0;
    text-align: center;
    padding-left: 14px;
    color: #525250;
    box-shadow: -2px -2px 4px #fff,
      4px 4px 4px #e6e6e1;
  }

  ::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
    text-align: center;
    color: #fff;
    padding-left: 14px;
    background-color: #5eb5bd;
    box-shadow: -2px -2px 4px #fff,
      4px 4px 4px #e6e6e1;
  }
}
</style>
